import styled from 'styled-components';
import PreviewResultsTable from 'modules/catalog/collectionBuilder/components/previewResultsTable';
import { useCatalogPreviewTableState } from './hooks/useCatalogPreviewTableState';

export const DATA_TEST = {
  table: 'catalog-preview-table',
  headerContent: 'table-header-content',
};

const HeaderContent = styled.div`
  ${({ theme }) => theme.styles.body.body2};
  color: ${({ theme }) => theme.colors.textColors.textSecondary};
`;

export const CatalogPreviewTable = () => {
  const {
    isCatalogPreviewTableLoading,
    catalogPreviewRows,
    isCatalogPreviewTableOpen,
    previewLimitMessage,
    catalogPreviewFieldTypes,
  } = useCatalogPreviewTableState();

  return (
    <div data-test={DATA_TEST.table}>
      <PreviewResultsTable
        headerContent={
          <HeaderContent data-test={DATA_TEST.headerContent}>{previewLimitMessage}</HeaderContent>
        }
        rows={catalogPreviewRows}
        didPreviewData={isCatalogPreviewTableOpen}
        isLoading={isCatalogPreviewTableLoading}
        fieldTypes={catalogPreviewFieldTypes}
      />
    </div>
  );
};
